/**
 * Property detail · Docs tab.
 *
 * Was a "coming soon" placeholder waiting on decisions about storage layout
 * and access. Those are settled by the apartment-documents model this now
 * reuses: bytes in the `contracts` bucket, provenance via source/uploaded_by,
 * and RLS keyed on the row's property_id — so a property-level document is
 * governed by exactly the rules already in force for the apartment ones.
 */
import { DocumentsPanel } from "@/components/admin/v2/documents/DocumentsPanel";

export function DocsTab({ propertyId }: { propertyId: number }) {
  return (
    <DocumentsPanel
      scope="property"
      propertyId={propertyId}
      source="admin"
      description="Files attached to the property as a whole — master lease, insurance, inspections. Documents for a specific unit or room live on that unit's or room's own tab."
    />
  );
}
